export const resolveMock = <T>(value: T, withError = false): Promise<T> => {
  return new Promise((resolve, rej) => {
    const timeout = setTimeout(() => {
      clearTimeout(timeout);

      if (withError) {
        rej(new Error('potato'));
      }
      resolve(value);
    }, 2000);
  });
};
